import { render, staticRenderFns } from "./AdministratorRegisterApplication.vue?vue&type=template&id=53732b1d&scoped=true&"
var script = {}
import style0 from "./AdministratorRegisterApplication.vue?vue&type=style&index=0&id=53732b1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53732b1d",
  null
  
)

export default component.exports